/**
 * Returns a distinct color for each role badge to ensure visual distinction
 * @param role - The role name (case-insensitive)
 * @returns MUI Chip color prop value
 */
export function getRoleBadgeColor(
  role: string
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' {
  switch (role.toLowerCase()) {
    case 'administrator':
      return 'error'; // Red for admin
    case 'employee':
      return 'success'; // Green for employee
    case 'intern':
      return 'primary'; // Indigo/blue for intern
    case 'manager':
      return 'warning'; // Orange/Amber for manager
    case 'seniormanager':
      return 'secondary'; // Purple for senior manager
    case 'teamlead':
      return 'info'; // Blue for team lead
    case 'reportingexempt':
      return 'default'; // Gray - excluded from stats
    default:
      return 'default'; // Gray for other roles
  }
}
